import React, { useState } from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { EmotionSection } from '../components/EmotionSection';
import { RegenerativeDifference } from '../components/RegenerativeDifference';
import { HowItWorks } from '../components/HowItWorks';
import { BeforeAfter } from '../components/BeforeAfter';
import { TestimonialCarousel } from '../components/TestimonialCarousel';
import { FAQAccordion } from '../components/FAQAccordion';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { ConsultationForm } from '../components/ConsultationForm';
import { StickyCallBar } from '../components/StickyCallBar';
export function HairRestorationPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  return <div className="min-h-screen bg-cream text-espresso font-sans selection:bg-gold/30 selection:text-espresso" data-id="element-171">
      <Header onBookConsultation={handleOpenModal} data-id="element-172" />

      <main data-id="element-173">
        <HeroSection onBookConsultation={handleOpenModal} data-id="element-174" />
        <BeforeAfter onBookConsultation={handleOpenModal} data-id="element-175" />
        <TrustBar data-id="element-176" />
        <EmotionSection data-id="element-177" />
        <RegenerativeDifference data-id="element-178" />
        <HowItWorks data-id="element-179" />
        <TestimonialCarousel data-id="element-180" />
        <FAQAccordion data-id="element-181" />
        <FinalCTA onBookConsultation={handleOpenModal} data-id="element-182" />
      </main>

      <Footer data-id="element-183" />

      <StickyCallBar data-id="element-184" />
      <ConsultationForm isOpen={isModalOpen} onClose={handleCloseModal} data-id="element-185" />
    </div>;
}